import validate from "/app/node_modules/.pnpm/nuxt@3.17.6_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@18.19.112_@vue+compiler-sf_x4dmmpj4uunswl5hv77q656qkm/node_modules/nuxt/dist/pages/runtime/validate.js";
import _1_45redirect_45to_45legacy_45app_45global from "/app/middleware/1.redirect-to-legacy-app.global.ts";
import _2_45redirect_45from_45json_45global from "/app/middleware/2.redirect-from-json.global.ts";
import _3_45gtm_45global from "/app/middleware/3.gtm.global.ts";
import handle_45session_45voucher_45global from "/app/middleware/handle-session-voucher.global.ts";
import notifications_45global from "/app/middleware/notifications.global.ts";
import scroll_45to_45top_45global from "/app/middleware/scrollToTop.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.6_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@18.19.112_@vue+compiler-sf_x4dmmpj4uunswl5hv77q656qkm/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _1_45redirect_45to_45legacy_45app_45global,
  _2_45redirect_45from_45json_45global,
  _3_45gtm_45global,
  handle_45session_45voucher_45global,
  notifications_45global,
  scroll_45to_45top_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "already-auth": () => import("/app/middleware/already-auth.ts"),
  auth: () => import("/app/middleware/auth.ts"),
  "event-old-permalinks": () => import("/app/middleware/event-old-permalinks.ts")
}